import { css } from 'styled-system/css';

export const tabStyle = {
	tabs: css({
		display: 'flex',
		justifyContent: 'center',
		borderBottomWidth: '3px',
		borderColor: 'jupiter.site.primaryFixed',
		fontSize: '16px',
		gap: '6px',
	}),
	tab: css({
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		minW: '150px',
		h: '42px',
		borderRadius: '6px 6px 0 0',
		cursor: 'pointer',
		_supportHover: {
			transition: 'background-color 200ms ease-in',
			'&:not([data-active="true"])': {
				_hover: {
					bgColor: '#CCC3'
				},
			}
		},
		_active: {
			color: 'jupiter.common.white',
			bgColor: 'jupiter.site.primaryFixed',
		},
		'& .icon': {
			mr: '6px',
		}
	}),
}